/* CARAVIUM PLANIFICAR — checkbox interaction fix */
(function(){
'use strict';
function init(){
  const style=document.createElement('style');
  style.textContent=`
    .cpv3-field input[type="checkbox"],
    .cpv3-check input[type="checkbox"]{
      width:16px!important;
      height:16px!important;
      min-width:16px!important;
      flex:0 0 16px!important;
      padding:0!important;
      margin:0!important;
      border:initial!important;
      border-radius:3px!important;
      background:initial!important;
      appearance:auto!important;
      -webkit-appearance:checkbox!important;
      accent-color:#14b8a6!important;
      cursor:pointer!important;
      pointer-events:auto!important;
      position:relative!important;
      opacity:1!important;
    }
    .cpv3-check{
      cursor:pointer!important;
      user-select:none!important;
      pointer-events:auto!important;
    }
    .cpv3-check *{pointer-events:auto!important;}

    /* PREMIUM POLISH — preferencias */
    body .cpv3[data-cvpw-step="prefs"] .cpv3-field .cpv3-prefs{
      gap:12px!important;
    }
    body .cpv3[data-cvpw-step="prefs"] .cpv3-field .cpv3-check{
      position:relative!important;
      display:flex!important;
      align-items:center!important;
      gap:12px!important;
      min-height:64px!important;
      padding:14px 16px!important;
      border:1px solid rgba(216,228,232,.95)!important;
      border-radius:16px!important;
      background:#fff!important;
      color:#123b5d!important;
      font-size:16px!important;
      font-weight:800!important;
      line-height:1.2!important;
      box-shadow:0 5px 14px rgba(3,20,34,.08)!important;
      overflow:hidden!important;
      transition:transform .18s ease,box-shadow .18s ease,border-color .18s ease,background .18s ease!important;
    }
    body .cpv3[data-cvpw-step="prefs"] .cpv3-field .cpv3-check:hover{
      transform:translateY(-1px)!important;
      box-shadow:0 8px 18px rgba(3,20,34,.11)!important;
    }
    body .cpv3[data-cvpw-step="prefs"] .cpv3-field .cpv3-check,
    body .cpv3[data-cvpw-step="prefs"] .cpv3-field .cpv3-check *{
      color:#123b5d!important;
      text-shadow:none!important;
    }
    body .cpv3[data-cvpw-step="prefs"] .cpv3-field .cpv3-check:has(input:checked){
      background:#ecfbf8!important;
      border-color:#55d7c9!important;
      color:#0d675f!important;
      box-shadow:0 0 0 1px rgba(85,215,201,.2),0 7px 18px rgba(3,20,34,.09)!important;
    }
    body .cpv3[data-cvpw-step="prefs"] .cpv3-field .cpv3-check:has(input:checked),
    body .cpv3[data-cvpw-step="prefs"] .cpv3-field .cpv3-check:has(input:checked) *{
      color:#0d675f!important;
    }
    body .cpv3[data-cvpw-step="prefs"] .cpv3-field .cpv3-check input[type="checkbox"]{
      appearance:none!important;
      -webkit-appearance:none!important;
      width:22px!important;
      height:22px!important;
      min-width:22px!important;
      flex:0 0 22px!important;
      margin:0!important;
      padding:0!important;
      border:2px solid #a8bac4!important;
      border-radius:7px!important;
      background:#fff!important;
      box-shadow:none!important;
      position:relative!important;
      cursor:pointer!important;
    }
    body .cpv3[data-cvpw-step="prefs"] .cpv3-field .cpv3-check input[type="checkbox"]:checked{
      background:#14b8a6!important;
      border-color:#14b8a6!important;
    }
    body .cpv3[data-cvpw-step="prefs"] .cpv3-field .cpv3-check input[type="checkbox"]:checked:after{
      content:'✓'!important;
      position:absolute!important;
      inset:0!important;
      display:flex!important;
      align-items:center!important;
      justify-content:center!important;
      color:#fff!important;
      font-size:14px!important;
      font-weight:900!important;
      line-height:1!important;
    }

    /* PREMIUM POLISH — dónde dormir */
    body .cpv3[data-cvpw-step="sleep"] .cvpw-sleep-grid{
      gap:12px!important;
    }
    body .cpv3[data-cvpw-step="sleep"] .cvpw-sleep-option{
      border-radius:18px!important;
      padding:20px 18px!important;
      min-height:150px!important;
      border:1px solid #d9e5e9!important;
      background:#fff!important;
      box-shadow:0 6px 16px rgba(3,20,34,.08)!important;
      transition:transform .18s ease,box-shadow .18s ease,border-color .18s ease!important;
    }
    body .cpv3[data-cvpw-step="sleep"] .cvpw-sleep-option:hover{
      transform:translateY(-2px)!important;
      box-shadow:0 10px 22px rgba(3,20,34,.11)!important;
    }
    body .cpv3[data-cvpw-step="sleep"] .cvpw-sleep-option.is-active{
      background:#ecfbf8!important;
      border:2px solid #55d7c9!important;
      box-shadow:0 0 0 2px rgba(85,215,201,.12),0 8px 20px rgba(3,20,34,.09)!important;
    }
    body .cpv3[data-cvpw-step="sleep"] .cvpw-sleep-icon{
      font-size:25px!important;
      margin-bottom:2px!important;
    }

    /* 'Cuéntale a CARAVIUM cómo quieres viajar' — cleaner premium card */
    body .cpv3[data-cvpw-step="sleep"] .cvpw-trip-notes-wrap{
      margin-top:16px!important;
      padding:18px 18px 16px!important;
      border:1px solid #d9e5e9!important;
      border-radius:18px!important;
      background:#fff!important;
      box-shadow:0 6px 16px rgba(3,20,34,.08)!important;
    }
    body .cpv3[data-cvpw-step="sleep"] .cvpw-trip-notes-wrap label{
      color:#123b5d!important;
      font-size:18px!important;
      font-weight:900!important;
      margin-bottom:5px!important;
    }
    body .cpv3[data-cvpw-step="sleep"] .cvpw-trip-notes-wrap p{
      color:#657987!important;
      font-size:14px!important;
      line-height:1.45!important;
      margin:0 0 12px!important;
    }
    body .cpv3[data-cvpw-step="sleep"] .cvpw-trip-notes-wrap textarea{
      min-height:112px!important;
      border:1px solid #cfdde3!important;
      border-radius:14px!important;
      background:#f8fbfc!important;
      color:#123b5d!important;
      padding:14px 15px!important;
      box-shadow:inset 0 1px 2px rgba(13,27,42,.03)!important;
      outline:none!important;
    }
    body .cpv3[data-cvpw-step="sleep"] .cvpw-trip-notes-wrap textarea:focus{
      background:#fff!important;
      border-color:#55d7c9!important;
      box-shadow:0 0 0 3px rgba(85,215,201,.14)!important;
    }

    /* Progress: flatter and cleaner */
    body .cpv3[data-cvpw-step="prefs"] .cvpw-progress,
    body .cpv3[data-cvpw-step="sleep"] .cvpw-progress,
    body .cpv3[data-cvpw-step="route"] .cvpw-progress{
      border-radius:13px!important;
      padding:10px 12px!important;
      background:rgba(255,255,255,.08)!important;
      border:1px solid rgba(255,255,255,.16)!important;
      box-shadow:none!important;
    }

    @media(max-width:700px){
      body .cpv3[data-cvpw-step="prefs"] .cpv3-field .cpv3-check{
        min-height:58px!important;
        padding:12px 14px!important;
        font-size:16px!important;
      }
      body .cpv3[data-cvpw-step="sleep"] .cvpw-sleep-option{
        min-height:104px!important;
        padding:16px!important;
      }
      body .cpv3[data-cvpw-step="sleep"] .cvpw-trip-notes-wrap{
        padding:15px!important;
      }
    }
  `;
  document.head.appendChild(style);

  document.addEventListener('click',function(e){
    const label=e.target.closest&&e.target.closest('.cpv3-check');
    if(!label)return;
    const cb=label.querySelector('input[type="checkbox"]');
    if(!cb)return;
    if(e.target!==cb){
      e.preventDefault();
      cb.checked=!cb.checked;
      cb.dispatchEvent(new Event('change',{bubbles:true}));
    }
  },true);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();